<template>
    <span v-if="value" class="badge badge-soft-secondary mt-n1 ml-1" :class="{'badge-soft-success':value>0,'badge-soft-danger':value<0}">{{ value }}%</span>
</template>

<script>
export default {
    props: ['value']

}
</script>

<style>

</style>
